"use strict";

/**
 * @classdesc
 * Basisklasse für Layer mit Inhalt (=Nicht-Gruppen-Layer).
 *
 * @abstract
 * @class
 * @extends gc.gis.layer.GCAbstractLayer
 * @memberof gc.gis.layer
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @constructor
 *
 * @param {Object}  options Aufrufoptionen.
 *      Siehe auch Optionen in {@link gc.gis.layer.GCAbstractLayer}.
 *
 * @param {boolean}  options.isInternal
 * 		(statische Eigenschaft) Interner Layer?
 *
 * @param {string}   options.baseUrl
 *      (statische Eigenschaft) Service-URL
 *
 * @param {string}   options.name
 *      (statische Eigenschaft) Layername
 *
 * @param {string}   [options.id=undefined]
 *      (statische Eigenschaft) Layer-ID
 *
 * @param {string}   [options.attribution=undefined]
 *      (statische Eigenschaft) Copyright
 *
 * @param {string}   [options.showLegend=true]
 *      (statische Eigenschaft) Erlauben ein Legendensymbol anzuzeigen?
 *
 * @param {number}   [options.minScale=undefined]
 *      (statische Eigenschaft) Minimaler Darstellungsmaßstab	// FIXME: nicht lieber dynamisch?
 *
 * @param {number}   [options.maxScale=undefined]
 *      (statische Eigenschaft) Maximaler Darstellungsmaßstab	// FIXME: nicht lieber dynamisch?
 *
 * @param {string[]} [options.availableProjections=[]]
 *      (statische Eigenschaft) Verfügbare Projektionen
 *
 * @param {string[]} [options.availableFormats=[]]
 *      (statische Eigenschaft) Verfügbare Datenformate
 *
 * @param {string[]} [options.availableVersions=[]]
 *      (statische Eigenschaft) Verfügbare Service-Versionen
 *
 * @param {string}   [options.projection=undefined]
 *      (dynamische Eigenschaft) Bevorzugte Projektion
 *
 * @param {string}   [options.format=undefined]
 *      (dynamische Eigenschaft) Bevorzugtes Datenformat
 *
 * @param {string}   [options.version=undefined]
 *      (dynamische Eigenschaft) Service-Version
 *
 * @param {gc.gis.map.GCMapExtent} [options.extent=undefined]
 *      Extent, wird ggf. dynamisch geladen
 *
 * @param {string}   [options.geometryTypes=[]]
 *      für diesen Layer erlaubte Geometrie-Typen (Fachdatenbank-Layer)
 *
 * @see {@link gc.gis.layer.GCAbstractLayer}
 */
gc.gis.layer.GCLayer = function( options )
{
	var node = new gc.gis.util.GCTreeNode({
		mutable: false,
		payload: this
	});

	gc.gis.layer.GCAbstractLayer.call( this, node, options );

	/**
	 * @type {gc.gis.map.GCMapExtent}
	 */
	this._extent = options.extent;

	this._setConfig('isInternal',  eval( options.isInternal ) === true );
	this._setConfig('baseUrl',     options.baseUrl );
	this._setConfig('name',        options.name );
	this._setConfig('id',          options.id );
	this._setConfig('attribution', options.attribution );
	this._setConfig('minScale',    parseFloat( options.minScale ) || undefined );
	this._setConfig('maxScale',    parseFloat( options.maxScale ) || undefined );
    this._setConfig('showLegend', gc.gis.GCUtil.parseBool(options.showLegend, true));
	this._setConfig('tooltipEnabled',       gc.gis.GCUtil.parseBool(options.tooltipEnabled, true));
	this._setConfig('availableProjections', options.availableProjections || [] );
	this._setConfig('availableFormats',     options.availableFormats || [] );
	this._setConfig('availableVersions',    options.availableVersions || [] );
	this._setConfig('allowedGeometryTypes', options.geometryTypes || []);

    this._setState('projection', options.projection);
    this._setState('format', options.format);
    this._setState('version', options.version);

    if (options.externalConnection) {
        this._setConfig('externalConnection', options.externalConnection);
    }
};
gc.gis.layer.GCLayer.prototype = Object.create( gc.gis.layer.GCAbstractLayer.prototype );

/**
 * Setzt die Ausdehnung des Layers. Hinweis: hat keinen Effekt auf interne
 * Layer, da diese stets die aktuelle Ausdehnung vom Server abrufen.
 *
 * @public
 * @method
 * @param {gc.gis.map.GCMapExtent} extent neue Layerausdehnung
 */
gc.gis.layer.GCLayer.prototype.setExtent = function( extent )
{
	this._extent = extent;
};

/**
 * @override
 * @inheritdoc
 */
gc.gis.layer.GCLayer.prototype.getExtent = function( callback, opt_crs )
{
	var self = this;
	var crs = opt_crs || gc.gis.iface.map.getProjection();

	if( this.isInternal() )
	{
		gc.gis.iface.request.ajax({
			label: 'Ermittle Ausdehnung ... ',
			context: this,
			url: gc.gis.GCUrl.buildUrl(gc.gis.iface.requests.layerExtentUrl, {'id': this.getId(), 'crs': crs}),
			success: function( data ) {
                self._extent = JSON.parse( data ).results;
                callback.call( self, {
                    layer: self,
                    extent:// gc.gis.iface.map.transformExtent(	// FIXME: serverseitig transformieren
                        self._extent//, self.getProjection(), crs
                    //)
                });
			}
		});
	}
	else if( this._extent )
	{
		callback.call( this, {
			layer: this,
			extent: gc.gis.iface.map.transformExtent(
				self._extent, self.getProjection(), crs
			)
		});
	}
	else
	{
		throw new gc.gis.error.GCError('Layerausdehnungen für "'+ this.getLabel() +'" ist nicht definiert.');
	}
};

/**
 * @override
 * @inheritdoc
 */
gc.gis.layer.GCLayer.prototype.getExtentSync = function( opt_crs )
{
	var self = this;
	var crs = opt_crs || gc.gis.iface.map.getProjection();

	if( !this._extent )
	{
		throw new gc.gis.error.GCError('Layerausdehnungen für "'+ this.getLabel() +'" ist nicht definiert.');
	}

	return gc.gis.iface.map.transformExtent(
		self._extent, self.getProjection(), crs
	);
};

/**
 * @public
 * @method
 * @return {boolean}
 */
gc.gis.layer.GCLayer.prototype.isInternal = function()
{
	return this.getConfig('isInternal');
};

/**
 * @public
 * @method
 * @return {string}
 */
gc.gis.layer.GCLayer.prototype.getId = function()
{
	return this.getConfig('id');
};

/**
 * Gibt die Basis-URL des Layers zurück.
 * <strong>Achtung:</strong> bei internen Layern wird <em>immer</em> die
 * {@link gc.gis.iface.requests.owsBaseUrl|Basis-OWS-Url}, die serverseitig
 * mitgeliefert wird zurückgegeben, da beim speichern von z.B. Ansichten die
 * URL mit gespeichert wird und dies z.B. bei einem Serverumzug zu Problemen
 * führen kann.
 *
 * @public
 * @method
 * @return {string}
 */
gc.gis.layer.GCLayer.prototype.getUrl = function()
{
	if( this.isInternal() )
	{
		return gc.gis.iface.requests.owsBaseUrl;
	}
	return this.getConfig('baseUrl');
};

/**
 * @public
 * @method
 * @return {string}
 */
gc.gis.layer.GCLayer.prototype.getName = function()
{
	return this.getConfig('name');
};

/**
 * @public
 * @method
 * @return {string}
 */
gc.gis.layer.GCLayer.prototype.getAttribution = function()
{
	return this.getConfig('attribution');
};

/**
 * @public
 * @method
 * @return {number}
 */
gc.gis.layer.GCLayer.prototype.getMinScale = function()
{
	return this.getConfig('minScale');
};

/**
 * @public
 * @method
 * @return {number}
 */
gc.gis.layer.GCLayer.prototype.getMaxScale = function()
{
	return this.getConfig('maxScale');
};

/**
 * @public
 * @method
 * @return {boolean}
 */
gc.gis.layer.GCLayer.prototype.getShowLegend = function()
{
	return this.getConfig('showLegend');
};

/**
 * @public
 * @method
 *
 */
gc.gis.layer.GCLayer.prototype.getVersion = function()
{
	return this._getState('version');
};

/**
 * @public
 * @method
 * @param {string} version
 */
gc.gis.layer.GCLayer.prototype.setVersion = function( version )
{
	this._setState('version', version );
};

/**
 * @public
 * @method
 * @return {string}
 */
gc.gis.layer.GCLayer.prototype.getFormat = function()
{
	return this._getState('format');
};

/**
 * @public
 * @method
 * @param {string} format
 */
gc.gis.layer.GCLayer.prototype.setFormat = function( format )
{
	this._setState('format', format );
};

/**
 * @public
 * @method
 * @return {string}
 */
gc.gis.layer.GCLayer.prototype.getProjection = function()
{
	return this._getState('projection');
};

/**
 * Setzt den Projektions<em>parameter</em>.
 * <strong>Hinweis:</strong> Es findet keine Transformation statt!
 *
 * @public
 * @method
 * @param {string} projection
 */
gc.gis.layer.GCLayer.prototype.setProjection = function( projection )
{
	this._setState('projection', projection );
};

/**
 * Liefert die externen Verbindungsparameter zu einem Layer. Dieser Mechanismus kann bei OWS-Layern im Kartenkatalog
 * verwendet werden, um die Requests (wie z.B. GetMap) direkt gegen den externen Dienst zusenden. Eine Kaskade über den
 * Kartenkatalog kann dann entfallen. Das Szenario kommt z.B. bei WMS-Caches oder WMTS zum Einsatz und dient
 * insbesondere der Performance Optimierung.
 *
 * @public
 * @method
 * @returns {Object}
 */
gc.gis.layer.GCLayer.prototype.getExternalConnectionSettings = function()
{
    return this.getConfig('externalConnection');
};

/**
 * Prüft, ob der Layer über externe Verbindungsparameter verfügt.
 *
 * @public
 * @method
 * @returns {boolean}
 * @see {@link gc.gis.layer.GCLayer.getExternalConnectionSettings}
 */
gc.gis.layer.GCLayer.prototype.hasExternalConnectionSettings = function()
{
	var settings = this.getConfig('externalConnection');
    return settings && settings.source && (settings.url || settings.urls);
};

/**
 * Zeigt an, ob der Layer einen Tooltip bereitstellt.
 *
 * @public
 * @method
 * @returns {boolean}
 */
gc.gis.layer.GCLayer.prototype.isTooltipEnabled = function()
{
	return this.getConfig('tooltipEnabled');
};

/**
 * Prüft, ob der GUI beim Laden des Layers gesperrt werden soll.
 *
 * @public
 * @method
 * @return {boolean}
 */
gc.gis.layer.GCLayer.prototype.loadModal = function () {
    return true;
};